export const slugify = (value: string): string => {
  if (!value) return "";

  return value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
};

export const getArticlePath = (id: number | string, title?: string): string => {
  const slug = slugify(title ?? "");
  return slug ? `/article/${id}/${slug}` : `/article/${id}`;
};
